import { REDUX_OPTIONAL_ASSOCIATION_KEYS } from '../../../redux/constants/association'
import getClassNameReduxUtil from '../../../redux/utils/get-class-name'

/**
 * Gets keys such as `Workout.exerciseLogs`
 * @param instance
 * @returns {string[]}
 */
export default function getOptionalAssociationKeysReduxUtil (instance) {
  const className = getClassNameReduxUtil(instance)
  return REDUX_OPTIONAL_ASSOCIATION_KEYS[className] || []
}
